import { IEHRApis } from "./IEHRApis"
import ApiUtils from "../ApiUtils"
import { IMedicalProfileResponse } from "../../interfaces/patient/IMedicalProfile"
import { ITreatmentPlanTemplate } from "../../interfaces/doctor/ITreatmentPlanTemplate"
import { IPatientNote } from "../../interfaces/patient/IPatientNotes"
import { get } from "lodash"
import { IRenewalNote, IRenewalNoteResponse, ISaveRenewalNoteRequest } from "../../interfaces/api/ehr/IRenewalNote"

// const GET_PATIENT_ACTIVITIES_URL: string = EHR_API_PREFIX + "/patientLogging/activity-search";
// // migrated to Ambrosia
// // const GET_PATIENT_ACTIVITY_LOGGING_URL: string = EHR_API_PREFIX + "/patientLogging/activity/filter"
// const GET_DIET_PLAN_TAGS_URL: string = EHR_API_PREFIX + "/tags/search?namespace=diet";
// const GET_DIET_PLAN_TEMPLATE_SEARCH: string = EHR_API_PREFIX + "/diet-plan-templates/search";
// const GET_ADD_TEMPLATE_URL: string = EHR_API_PREFIX + "/diet-plan-templates/addTemplate";
// const GET_DIAGNOSTIC_REPORT: string = EHR_API_PREFIX + "/sections/regex-match-reference-id?doctorType=LC&patientId=$patientId&referenceId=$referenceId&subSectionKeySet=diagnosticOrderReportDetails";
// const SAVE_PATIENT_NOTES = EHR_API_PREFIX + "/patientNotes";
// const GET_PATIENT_NOTES = EHR_API_PREFIX + "/patientNotes/$patientId";
// const DELETE_PATIENT_NOTES = EHR_API_PREFIX + "/patientNotes/$noteId";
// const GET_RENEWAL_NOTE = EHR_API_PREFIX + "/medicalProfileWrapper?patientId=$patientId&subSectionKeySet=coachRenewalComment";
// const GET_PATIENT_MEDICAL_PROFILE_SUB_SECTION = EHR_API_PREFIX + "/medicalProfileWrapper";

const EHRApiUrls = {
	fetchMedicalProfile: "/medicalProfileWrapper",
	saveMedicalProfile: (patientId: number, appointmentId: number) => `/medicalProfileWrapper/${patientId}?referenceId=${appointmentId}`,
	recommendations: "/recommendations",
	getDoctorTreatmentPlanTemplates: (doctorId: number) => `/prescriptionTemplates/doctor/${doctorId}/all`,
	deleteDoctorTreatmentPlanTemplate: (templateId: string) => `/prescriptionTemplates/${templateId}`,
	saveDoctorTreatmentPlanTemplate: `/prescriptionTemplates/add`,
	getPatientNotes: (patientId: number) => `/patientNotes/${patientId}`,
	renewalNote: (patientId: number) => `/medicalProfileWrapper?patientId=${patientId}&subSectionKeySet=coachRenewalComment`,
	savePatientNotes: "/patientNotes",
	saveRenewalNote: (patientId: string) => `/medicalProfileWrapper/${patientId}`,
}
export default class EHRApis implements IEHRApis {
	getServiceUrl = (url: string) => "/ehr" + url
	getSubSectionsRecommendations(userId: number, userType: string, speciality: string, contexts: string[]): Promise<any> {
		const contextQuery = contexts.map((item: string) => ({
			context: item,
			speciality,
			userId,
		}))
		return ApiUtils.post(this.getServiceUrl(EHRApiUrls.recommendations), contextQuery)
	}

	getMedicalProfile(patientId: number, referenceId: number, doctorType: string): Promise<IMedicalProfileResponse> {
		const url = this.getServiceUrl(`${EHRApiUrls.fetchMedicalProfile}?${ApiUtils.requestToQueryParams({ patientId, referenceId, doctorType })}`)
		return ApiUtils.get(url)
	}
	//
	saveMedicalProfile(patientId: number, payload: any, appointmentId: number): Promise<any> {
		return ApiUtils.post(this.getServiceUrl(EHRApiUrls.saveMedicalProfile(patientId, appointmentId)), payload)
	}

	savePatientNotesOOC(patientId: number, patientNotesOOC: any): Promise<void> {
		const url = this.getServiceUrl(`${EHRApiUrls.fetchMedicalProfile}/${patientId}`)
		return ApiUtils.post(url, { newConfigData: { patientNotesOOC: patientNotesOOC } })
	}
	//
	// getPatientNotesOOC = (patientId: number): Promise<IPatientNotesOOC[]> => {
	// 	let url = GET_PAST_SESSIONS + "?patientId=" + patientId.toString() + "&subSectionKey=patientNotesOOC";
	// 	return ApiUtils.apiGetRequest(url);
	// };
	//
	// getTreatmentPlanTemplates = (userId: number, diagnosis: Array<string>): Promise<Array<ITreatmentPlanTemplateResponseObj>> => {
	// 	const url = AlbusUrlConfigs.getDoctorTreatmentPlanTemplatesUrl(userId, diagnosis);
	// 	return ApiUtils.apiGetRequest(url);
	// };
	//
	getAllTreatmentPlanTemplates = (doctorId: number): Promise<ITreatmentPlanTemplate[]> => {
		return ApiUtils.get(this.getServiceUrl(EHRApiUrls.getDoctorTreatmentPlanTemplates(doctorId)))
	}
	//
	// getTreatmentPlanTemplatesByName = (userId: number, query: string): Promise<Array<ITreatmentPlanTemplateResponseObj>> => {
	// 	const url = AlbusUrlConfigs.getDoctorTreatmentPlanTemplatesByNameUrl(userId, query);
	// 	return ApiUtils.apiGetRequest(url);
	// };
	//
	getTreatmentPlanTemplatesById = (templateId: string): Promise<ITreatmentPlanTemplate> => {
		return ApiUtils.get(this.getServiceUrl(EHRApiUrls.deleteDoctorTreatmentPlanTemplate(templateId)))
	}

	deleteTreatmentPlan = (templateId: string): Promise<any> => {
		return ApiUtils.delete(this.getServiceUrl(EHRApiUrls.deleteDoctorTreatmentPlanTemplate(templateId)), {})
	}
	//
	saveTreatmentPlanTemplate = (template: ITreatmentPlanTemplate): Promise<any> => {
		return ApiUtils.post(this.getServiceUrl(EHRApiUrls.saveDoctorTreatmentPlanTemplate), template)
	}
	//
	// getSectionAllowed = (doctorType: string, sectionKey: string): Promise<any> => {
	// 	const url = AlbusUrlConfigs.getSectionAllowedUrl(doctorType, sectionKey);
	// 	return ApiUtils.apiHeadRequest(url);
	// };
	//
	// fetchPatientActivities(patientId: number): Promise<any> {
	// 	const url: string = GET_PATIENT_ACTIVITIES_URL;
	// 	return ApiUtils.apiPostRequest(url, JSON.stringify({ patientId: patientId }));
	// }
	//
	// getIntervantionsSummary(data: IFetchScheduledInterventionsProgressRequest, patientId: string): Promise<Array<IFetchScheduledInterventionsProgresssResponse>> {
	// 	const url: string = AlbusUrlConfigs.getScheduledInterventionsProgress(patientId);
	// 	return ApiUtils.apiPostRequest(url, JSON.stringify(data));
	// }
	//
	// getScheduledInterventions(data: IFetchScheduledInterventionsRequest): Promise<Array<IFetchScheduledInterventionsResponse>> {
	// 	const url: string = AlbusUrlConfigs.getScheduledInterventions();
	// 	return ApiUtils.apiPostRequest(url, JSON.stringify(data));
	// }
	//
	// getScheduledInterventionsHistory(patientId: string): Promise<{ [key: string]: IFetchScheduledInterventionsResponse[] }> {
	// 	const url: string = AlbusUrlConfigs.getScheduledInterventionsHistory(patientId);
	// 	return ApiUtils.apiPostRequest(url, JSON.stringify({ patientId: parseInt(patientId) }));
	// }
	//
	// getDietPlanTags(): Promise<{ name: string }[]> {
	// 	return ApiUtils.apiGetRequest(GET_DIET_PLAN_TAGS_URL);
	// }
	//
	// getDietPlanTemplates(params: IDietPlanTemplateSearchParams): Promise<IDietTemplate[]> {
	// 	return ApiUtils.apiPostRequest(GET_DIET_PLAN_TEMPLATE_SEARCH, JSON.stringify(params));
	// }
	//
	// saveMealTemplate(mealTemplate: IDietTemplate): Promise<IDietTemplate> {
	// 	return ApiUtils.apiPostRequest(GET_ADD_TEMPLATE_URL, JSON.stringify(mealTemplate));
	// }
	//
	// getPatientDiagnosticReport(patientId: string, referenceId: string): Promise<IDiagnosticLabReportResponse> {
	// 	const url: string = GET_DIAGNOSTIC_REPORT.replace("$patientId", patientId).replace("$referenceId", referenceId);
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	async getRenewalNote(patientId: number): Promise<IRenewalNoteResponse> {
		const response = await ApiUtils.get(this.getServiceUrl(EHRApiUrls.renewalNote(patientId)))
		return get(response, "newConfigData", {})
	}
	
	saveRenewalNote(patientId: string, renewalNote: IRenewalNote): Promise<IRenewalNoteResponse> {
		const url = this.getServiceUrl(EHRApiUrls.saveRenewalNote(patientId))
		const payload: ISaveRenewalNoteRequest = {
			newConfigData: {
				coachRenewalComment: renewalNote,
			},
		};
		return ApiUtils.post(url, payload);
	}
	//
	// // migrated to Ambrosia
	// // fetchPatientActivityLogging(param: ICgmActivitiesSearchParams): Promise<IPatientActivityImpactItem[]> {
	// //     return ApiUtils.apiPostRequest(GET_PATIENT_ACTIVITY_LOGGING_URL, JSON.stringify(param));
	// // }
	//
	savePatientNote(param: IPatientNote): Promise<IPatientNote> {
		const url = this.getServiceUrl(EHRApiUrls.savePatientNotes)
		return ApiUtils.post(url, param)
	}

	getPatientNotes(patientId: number): Promise<IPatientNote[]> {
		return ApiUtils.get(this.getServiceUrl(EHRApiUrls.getPatientNotes(patientId)))
	}
	//
	// deletePatientNotes(id: string): Promise<void> {
	// 	return ApiUtils.apiDeleteRequest(DELETE_PATIENT_NOTES.replace("$noteId", id), JSON.stringify({}));
	// }
	//
	getPatientMedicalProfileWithSubsectionKey(patientId: number, subSectionKeySet: string): Promise<any> {
		const url = this.getServiceUrl(EHRApiUrls.fetchMedicalProfile) + "?" + ApiUtils.requestToQueryParams({ patientId, subSectionKeySet })
		return ApiUtils.get(url)
	}
}
